import styled from '@emotion/styled';
import { BodyTextMedium, Button, HeadingText50, pxToRem } from '@modernhealth/vital-components';
import React from 'react';
import { PageContentContainer } from 'src/modules/pathways/components/PageLayout';

export interface PathwaySessionCompleteProps {
    title: string;
    description: string;
    image: React.ReactNode;
    primaryButtonText: string;
    primaryButtonAction: () => void;
    secondaryButtonText?: string | undefined;
    secondaryButtonAction?: () => void | undefined;
}

export const PathwaySessionComplete: React.FC<PathwaySessionCompleteProps> = ({
    title,
    description,
    image,
    primaryButtonText,
    primaryButtonAction,
    secondaryButtonText,
    secondaryButtonAction,
}) => {
    return (
        <Container>
            {image}
            <HeadingText50 centered>{title}</HeadingText50>
            <BodyTextMedium centered marginBottom={44}>
                {description}
            </BodyTextMedium>
            <ButtonContainer>
                <Button fluid variant="primary" size="large" onClick={primaryButtonAction}>
                    {primaryButtonText}
                </Button>
                {secondaryButtonText ? (
                    <Button
                        css={{ marginTop: pxToRem(18), background: 'none' }}
                        fluid
                        variant="flat"
                        size="large"
                        onClick={secondaryButtonAction}
                    >
                        {secondaryButtonText}
                    </Button>
                ) : null}
            </ButtonContainer>
        </Container>
    );
};

const Container = styled(PageContentContainer)({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: pxToRem(560),
});

const ButtonContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'column',
    minWidth: pxToRem(270),
});
